/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { BACKGROUND_COLORS } from 'bundles/promo-units/components/banner-ad';
import { styles } from 'bundles/promo-units/components/banner-ad/__styles__/BannerAd';
import { numToPx } from 'bundles/promo-units/components/banner-ad/utils';

// Why "Soapbox?"
// The CSS name "banner-ad" triggers ad blockers.
// Why two containers, inner and outer?
// TrackedDiv injects an extra div which above itself
// when withVisibilityTracking is set!
// And that div gets no styling / cannot be styled!

const BannerAdPlaceholder = ({ className, heightInPixels }: { className: string; heightInPixels?: number }) => {
  const backgroundColor = BACKGROUND_COLORS.white;

  let containerStyle: React.CSSProperties | undefined;

  if (heightInPixels) {
    containerStyle = { maxHeight: numToPx(heightInPixels) };
  }

  return (
    <div css={styles.bannerAdOuterContainer} className={className}>
      <div
        css={styles.bannerAdInnerContainer}
        className={backgroundColor}
        data-testid="banner-ad-placeholder"
        style={containerStyle}
      >
        <div css={styles.leftSideContainer}>
          <div>
            <div className="partner-name" css={[styles.shimmer, styles.partnerPlaceholder]} />
            <div className="title" css={[styles.shimmer, styles.title, styles.titlePlaceholder]} />
          </div>
          <p css={[styles.shimmer, styles.bodyText, styles.bodyTextPlaceholder]} />
          <span css={[styles.shimmer, styles.ctaPlaceholder]} />
        </div>
      </div>
    </div>
  );
};

export default BannerAdPlaceholder;
